import { useTranslation } from 'react-i18next';
import * as S from './styled';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export function FAQs() {
  const { t } = useTranslation();
  const [active, setActive] = useState('');
  const { lang } = useParams();

  const faqs = [
    [
      {
        key: '2',
        label: t('faqs.text_2_1'),
        children: <div dangerouslySetInnerHTML={{ __html: t('faqs.text_2_2') }} />,
      },
    ],
    [
      {
        key: '3',
        label: t('faqs.text_3_1'),
        children: <div dangerouslySetInnerHTML={{ __html: t('faqs.text_3_2') }} />,
      },
    ],
    [
      {
        key: '4',
        label: t('faqs.text_4_1'),
        children: <div dangerouslySetInnerHTML={{ __html: t('faqs.text_4_2') }} />,
      },
    ],
    [
      {
        key: '5',
        label: t('faqs.text_5_1'),
        children: <div dangerouslySetInnerHTML={{ __html: t('faqs.text_5_2') }} />,
      },
    ],
    [
      {
        key: '6',
        label: t('faqs.text_6_1'),
        children: <div dangerouslySetInnerHTML={{ __html: t('faqs.text_6_2') }} />,
      },
    ],
    [
      {
        key: '7',
        label: t('faqs.text_7_1'),
        children: <div dangerouslySetInnerHTML={{ __html: t('faqs.text_7_2') }} />,
      },
    ],
    [
      {
        key: '8',
        label: t('faqs.text_8_1'),
        children: <div dangerouslySetInnerHTML={{ __html: t('faqs.text_8_2') }} />,
      },
    ],
  ];

  const collapseProps = {
    onChange: (s: string) => setActive(s),
    expandIcon: ({ isActive }: any) =>
      isActive ? (
        <img src={`${process.env.PUBLIC_URL}/images/faq/remove.png`} alt="/images/faq/remove.png" />
      ) : (
        <img src={`${process.env.PUBLIC_URL}/images/faq/add.png`} alt="/images/faq/add.png" />
      ),
    expandIconPosition: 'end',
    defaultActiveKey: [active],
  };

  return (
    <S.FAQsStyled>
      <S.FAQsTitleStyled>{t('faqs.text_1')}</S.FAQsTitleStyled>

      <S.FAQsListStyled>
        <S.ColStyled>
          {faqs.map((item, index) =>
            index % 2 === 0 ? (
              <S.FAQsItemStyled key={index}>
                <S.CollapseStyled lang={lang} key={index} {...collapseProps} items={item} />
              </S.FAQsItemStyled>
            ) : (
              ''
            ),
          )}
        </S.ColStyled>
        <S.ColStyled>
          {faqs.map((item, index) =>
            index % 2 !== 0 ? (
              <S.FAQsItemStyled key={index}>
                <S.CollapseStyled lang={lang} key={index} {...collapseProps} items={item} />
              </S.FAQsItemStyled>
            ) : (
              ''
            ),
          )}
        </S.ColStyled>
      </S.FAQsListStyled>
    </S.FAQsStyled>
  );
}
